<dx-popup
    #documentsPopup
    width="60%"
    height="70%"
    [title]="popupTitle"
    [showCloseButton]="true"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" id="documentContainer">
        <dx-box
            *ngIf="!!documentTree"
            class="document-container cc-document-container"
            height="100%"
            width="100%"
            direction="col"
        >
            <dxi-item [ratio]="1">
                <div *dxTemplate class="drawer-content cc-white-background">
                    <dx-drawer
                        *ngIf="documentTree.length > 0"
                        class="layout-body"
                        position="left"
                        height="100%"
                        width="100%"
                        [closeOnOutsideClick]="shaderEnabled"
                        [(opened)]="isDrawerOpen"
                        [revealMode]="menuRevealMode"
                        [shading]="shaderEnabled"
                        template="template"
                    >
                        <div class="documents-drawer-panel" *dxTemplate="let data of 'template'">
                            <dx-box width="100%" height="100%" direction="col">
                                <dxi-item baseSize="auto" [visible]="searchEnabled || allowAllExpandCollapse">
                                    <div *dxTemplate>
                                        <div class="search-container dx-theme-border-color">
                                            <div class="search-content">
                                                <dx-text-box
                                                    *ngIf="searchEnabled"
                                                    placeholder="Search Folder..."
                                                    [elementAttr]="{ class: 'text-content' }"
                                                    [showClearButton]="true"
                                                    [(value)]="searchText"
                                                    (onValueChanged)="onSearchTree()"
                                                    (onEnterKey)="onSearchTree()"
                                                    (onInput)="onSearchInputChange($event)"
                                                >
                                                    <dxi-button
                                                        name="search"
                                                        location="before"
                                                        [options]="searchButtonOptions"
                                                    ></dxi-button>
                                                    <dxi-button name="clear" location="after"></dxi-button>
                                                </dx-text-box>
                                            </div>
                                            <div class="expand-collapse-button-content" *ngIf="allowAllExpandCollapse">
                                                <div class="button-content">
                                                    <dx-button
                                                        type="normal"
                                                        stylingMode="text"
                                                        hint="Expand All"
                                                        [icon]="iconExpand"
                                                        (onClick)="onExpandClick()"
                                                    ></dx-button>
                                                </div>
                                                <div class="button-content">
                                                    <dx-button
                                                        type="normal"
                                                        stylingMode="text"
                                                        hint="Collapse All"
                                                        [icon]="iconCollapse"
                                                        (onClick)="onCollapseClick()"
                                                    ></dx-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </dxi-item>
                                <dxi-item [ratio]="1">
                                    <div *dxTemplate>
                                        <dx-tree-list
                                            #documentTreeList
                                            keyExpr="id"
                                            parentIdExpr="parentId"
                                            height="100%"
                                            [width]="246"
                                            [dataSource]="documentTree"
                                            [showRowLines]="false"
                                            [autoExpandAll]="true"
                                            [showColumnHeaders]="false"
                                            [(selectedRowKeys)]="selectedKey"
                                            (onCellClick)="onDocumentTreeCellClick($event)"
                                        >
                                            <dxo-selection mode="single"></dxo-selection>
                                            <dxo-scrolling mode="standard"></dxo-scrolling>
                                            <dxi-column
                                                dataField="text"
                                                cellTemplate="cellTemplate"
                                                caption="Categories"
                                            >
                                                <div *dxTemplate="let cell of 'cellTemplate'">
                                                    <i class="dx-icon-folder"></i>
                                                    {{ cell.data.text }}
                                                </div>
                                            </dxi-column>
                                        </dx-tree-list>
                                    </div>
                                </dxi-item>
                            </dx-box>
                        </div>
                        <cc-data-grid-features
                            *ngIf="!!documentsResult"
                            [gridFeatures]="{ allowGrouping: false, noDataText: emptyDocumentsNote }"
                            [dataSource]="documentsResult"
                        >
                            <dx-data-grid
                                #fileListDataGrid
                                [dataSource]="documentsResult"
                                class="document-tree-data-grid"
                                keyExpr="fileId"
                                [noDataText]="emptyDocumentsNote"
                                [(selectedRowKeys)]="selectedDocumentKeys"
                                (onSelectionChanged)="onFilesSelection($event)"
                                (onCellPrepared)="onCellPrepared($event)"
                            >
                                <dxi-column
                                    alignment="center"
                                    caption=""
                                    cellTemplate="selectButtonTemplate"
                                    [width]="100"
                                    [visible]="selectionMode === 'single'"
                                    [showInColumnChooser]="selectionMode === 'single'"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="fileName"
                                    cellTemplate="cellTemplate"
                                    caption="Files"
                                >
                                    <div *dxTemplate="let cell of 'cellTemplate'" class="cc-hyperlink">
                                        <i class="margin-right-5px" [ngClass]="getFileIconByExtension(cell.value)"></i>
                                        <app-hyperlink-creator
                                            mode="hyperlinkOnly"
                                            [displayText]="cell.value"
                                            (onLinkClick)="onDownloadFile(cell.data)"
                                        ></app-hyperlink-creator>
                                    </div>
                                </dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="sizeDisplayText"
                                    cellTemplate="sizeTemplate"
                                    caption="Size"
                                >
                                    <div *dxTemplate="let cell of 'sizeTemplate'">
                                        <span>{{ formatFileSize(cell.data.size) }}</span>
                                    </div>
                                </dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="description"
                                    caption="Description"
                                ></dxi-column>
                                <dxi-column
                                    dataField="effectiveDate"
                                    dataType="date"
                                    [format]="dateFormat"
                                    caption="Effective Date"
                                ></dxi-column>
                                <dxo-group-panel [visible]="false"></dxo-group-panel>
                                <dxo-selection
                                    showCheckBoxesMode="always"
                                    [mode]="selectionMode"
                                    [allowSelectAll]="false"
                                ></dxo-selection>
                                <dxo-paging [enabled]="false"></dxo-paging>
                                <dxo-load-panel [enabled]="false"></dxo-load-panel>
                                <div *dxTemplate="let t of 'selectButtonTemplate'">
                                    <dx-button
                                        type="default"
                                        text="Attach"
                                        [icon]="iconAttachment"
                                        [visible]="isFileSelectable(t.data)"
                                        (onClick)="onSingleAttachClick(t.data)"
                                    ></dx-button>
                                </div>
                            </dx-data-grid>
                        </cc-data-grid-features>
                    </dx-drawer>
                    <div *ngIf="isEmptyDocumentTree" class="no-data-content cc-text-required">
                        {{ noDataText }}
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto" [visible]="selectionMode === 'multiple'">
                <dx-box width="100%" direction="row">
                    <dxi-item [ratio]="1">
                        <div *dxTemplate class="progress-bar-container" [ngClass]="{ 'cc-hidden': !showSizeLimit }">
                            <dx-progress-bar
                                [elementAttr]="{ class: 'progress-bar-control' }"
                                [width]="250"
                                [height]="32"
                                [max]="maxAllowedSize"
                                [value]="selectedSize"
                                [showStatus]="false"
                            ></dx-progress-bar>
                            <span class="progress-bar-label">{{ formatFileSize(selectedSize) }} / 25MB</span>
                            <div *ngIf="maxSizeError" class="cc-text-required">{{ maxSizeError }}</div>
                        </div>
                    </dxi-item>
                    <dxi-item baseSize="auto">
                        <dx-button
                            text="Attach"
                            type="success"
                            hint="Attach"
                            [icon]="iconAttachment"
                            [visible]="!!documentTree && documentTree.length > 0"
                            (onClick)="onMultiAttachClick(selectedSize)"
                        ></dx-button>
                        <dx-button
                            text="Close"
                            type="default"
                            hint="Close"
                            [icon]="iconClose"
                            [visible]="!documentTree || documentTree.length === 0"
                            (onClick)="onHidden()"
                        ></dx-button>
                    </dxi-item>
                </dx-box>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    [position]="{ of: '#documentContainer' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
